"use strict";var e=require("react");exports.u=r=>{const t=e.useRef(r);return e.useEffect(()=>{t.current=r},[r]),t.current};